import { ChevronDown } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxiYXJiZXIlMjBoYWlyY3V0fGVufDB8fHx8MTc4OTA1NDMyNXww&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section data-testid="hero-section" className="relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_IMG})` }}
      />
      <div className="hero-overlay absolute inset-0" />
      <div className="relative mx-auto flex min-h-[540px] max-w-md flex-col justify-end px-4 pb-14 pt-24 md:max-w-2xl lg:max-w-4xl">
        <span
          data-testid="hero-badge"
          className="eyebrow animate-fade-up mb-4 inline-flex w-fit items-center rounded-full border border-amber-500/30 bg-amber-500/10 px-3 py-1.5"
        >
          Tradição & Estilo Minimalista
        </span>
        <h1
          data-testid="hero-title"
          className="font-display animate-fade-up text-5xl leading-[0.95] text-amber-100 sm:text-6xl"
          style={{ animationDelay: "0.1s" }}
        >
          Seu corte,
          <br />
          <span className="text-amber-400">no seu horário.</span>
        </h1>
        <p
          data-testid="hero-subtitle"
          className="animate-fade-up mt-4 max-w-sm text-base leading-relaxed text-zinc-300"
          style={{ animationDelay: "0.2s" }}
        >
          Agende em menos de 1 minuto, sem cadastro. Escolha o serviço, o dia e a
          hora — e pague online ou na barbearia.
        </p>
        <div
          className="animate-fade-up mt-8 flex flex-wrap items-center gap-3"
          style={{ animationDelay: "0.3s" }}
        >
          <button
            data-testid="hero-agendar-button"
            onClick={() => scrollTo("agendar")}
            className="gold-glow rounded-full bg-amber-500 px-7 py-3.5 text-sm font-bold uppercase tracking-wider text-zinc-950 transition-all hover:bg-amber-400 active:scale-95"
          >
            Agendar Agora
          </button>
          <button
            data-testid="hero-services-button"
            onClick={() => scrollTo("servicos")}
            className="rounded-full border border-zinc-600 px-7 py-3.5 text-sm font-semibold text-zinc-200 transition-colors hover:border-amber-500/60 hover:text-amber-300"
          >
            Ver Serviços
          </button>
        </div>
        <ChevronDown className="mx-auto mt-10 h-5 w-5 animate-bounce text-amber-500/60" />
      </div>
    </section>
  );
}
